import React from 'react';

const HIGHLIGHT_TERMS = [
  'FORCE',
  'VELOCITY',
  'POWER',
  'ACCELERATION',
  'CNS',
  'ENGINE',
];

export const highlightTerms = (text) => {
  if (!text || typeof text !== 'string') return text;
  
  const regex = new RegExp(`\\b(${HIGHLIGHT_TERMS.join('|')})\\b`, 'g');
  const parts = text.split(regex);
  
  return parts.map((part, index) => {
    if (HIGHLIGHT_TERMS.includes(part)) {
      return (
        <span key={index} className="text-[#D31113] font-bold">
          {part}
        </span>
      );
    }
    return part;
  });
};
